import { APP_INITIALIZER, NgModule, Provider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TemplateModule } from './template/template.module';
import { HomeComponent } from './components/home/home.component';
import { UserService } from './users/services/user.service';
import { TranslocoRootModule } from './transloco-root.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OAuthModule }  from 'angular-oauth2-oidc';
import { AppInitializationService } from './app-initialization.service';
import { QmLoaderModule, QmLoaderService, QmToastModule } from '@md2/md2-component-lib';
import { LoaderInterceptor } from './auth/loader.interceptor';

export const loadApplicationInit: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: (appInit: AppInitializationService) => () => appInit.init(),
  deps: [AppInitializationService]
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent
  ],
  imports: [
    OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.apiGatewayUrl + environment.endPointSufix],
          sendAccessToken: true
        }
    }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    TemplateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoRootModule,
    LayoutModule,
    QmLoaderModule,
    QmToastModule
  ],
  providers: [
    UserService,
    QmLoaderService,
    loadApplicationInit,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
